import { secureScoreProfiles } from './secure-score-profile'

import {
  convertSecureScoreProfileTypesToConstantCases,
  getSecureScoreProfileTypesWithIndex,
} from './secure-score-profile-utils'

/** @typedef {import ('./constants').SecureScoreProfileType} SecureScoreProfileType */

export default class SecureScoreProfileConstants {
  constructor(params) {
    const { COMPLIANCE_TYPES } = params || {}
    if (!COMPLIANCE_TYPES) {
      throw new Error('SecureScoreProfileConstants:constructor - COMPLIANCE_TYPES is required')
    }

    this.COMPLIANCE_TYPES = COMPLIANCE_TYPES
  }

  /** @returns {Record<SecureScoreProfileType, object>} */
  secureScoreProfiles() {
    const { COMPLIANCE_TYPES } = this ?? this

    if (!COMPLIANCE_TYPES) {
      throw new Error('SecureScoreProfileConstants:secureScoreProfiles - COMPLIANCE_TYPES is required')
    }

    return secureScoreProfiles({ COMPLIANCE_TYPES })
  }

  /** @returns {SecureScoreProfileType[]} */
  getSecureScoreProfileKeys() {
    const profiles = this.secureScoreProfiles()
    return Object.entries(profiles).map(([key, value]) => (value == null || value === '' ? null : key))
  }

  /** @type {Record<Uppercase<SecureScoreProfileType>, SecureScoreProfileType>} */
  get SECURE_SCORE_PROFILE_TYPES() {
    return Object.freeze({
      ...convertSecureScoreProfileTypesToConstantCases(this.getSecureScoreProfileKeys()),
    })
  }

  /** @returns {Record<SecureScoreProfileType, object>} */
  getSecureScoreProfiles() {
    return Object.freeze(this.secureScoreProfiles())
  }

  /** @returns {Record<number, SecureScoreProfileType>} */
  getSecureScoreProfileTypesWithIndex(startIndex) {
    return Object.freeze(getSecureScoreProfileTypesWithIndex(startIndex, this.getSecureScoreProfileKeys()))
  }
}
